<div id="test">

</div>

<div class="firstTotast" *ngIf="firstTotast">
  <div class="firstTotastWrap">
    <img src="{{assetsRoute}}/picture/reportnew/left.png" alt=""  class="leftIcon"/>
    <img src="{{assetsRoute}}/picture/reportnew/hand.png" alt="" class="handIcon" />
    <p>向左滑动切换上一题</p>
    <button (click)="closeTotast()">朕知道了</button>
  </div>
</div>

<div id="cards" class="cards">
  <div class="card" *ngFor="let item of cardItems;">
    <div class="bgPic" [ngClass]="{'hide':abilityTest}"></div>
      <section *ngIf="!isHarmonyOS" [ngClass]="{'fontSize21':!abilityTest,'lineHeight33':!abilityTest,'fontSize16':abilityTest,'lineHeight24':abilityTest,'characterPaddingTop':!abilityTest,'abilityPaddingTop':abilityTest}">
        <p>
          {{question.description}}
        </p>
      </section>
      <section *ngIf="isHarmonyOS"  [ngClass]="{'characterPaddingTop':!abilityTest,'abilityPaddingTop':abilityTest}" [ngStyle]="{'font-size': abilityTest ? '16px' : '21px'}">
        <p>
          {{question.description}}
        </p>
      </section>
    <div class="demoOut" *ngIf="!abilityTest">
      <svg width="100%" height="100%" viewBox="0 0 636 318" version="1.1" xmlns="http://www.w3.org/2000/svg" class="svg-options">
        <g class="choice" (tap)="onClickOption(0)">
          <path d="M0 318 A318 318 0 0 1 60.74 131.09 L196.64 229.83 A150 150 0 0 0 168 318 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="60"  y="265" style="font-size:32px; fill: #4a4a4a;">不符</text>
        </g>
        <g class="choice" (tap)="onClickOption(1)">
          <path d="M60.74 131.09 A318 318 0 0 1 219.93 15.56 L271.65 175.34 A150 150 0 0 0 196.64 229.83 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="130"  y="145" style="font-size:32px; fill: #4a4a4a;">较不符</text>
        </g>
        <g class="choice" (tap)="onClickOption(2)">
          <path d="M219.93 15.56 A318 318 0 0 1 416.73 15.56 L364.35 175.34 A150 150 0 0 0 271.65 175.34 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="270"  y="100" style="font-size:32px; fill: #4a4a4a;">不确定</text>
        </g>
        <g class="choice" (tap)="onClickOption(3)">
          <path d="M416.73 15.56 A318 318 0 0 1 575.26 131.09 L439.35 229.83 A150 150 0 0 0 364.35 175.34 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="410"  y="145" style="font-size:32px; fill: #4a4a4a;">较符合</text>
        </g>
        <g class="choice" (tap)="onClickOption(4)">
          <path d="M575.26 131.09 A318 318 0 0 1 636 318 L468 318 A150 150 0 0 0 439.35 229.83 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="510"  y="265" style="font-size:32px; fill: #4a4a4a;">符合</text>
        </g>
      </svg>
    </div>
    <div class="demoOut" *ngIf="abilityTest">
      <svg width="100%" height="100%" viewBox="0 0 636 318" version="1.1" xmlns="http://www.w3.org/2000/svg" class="svg-options">
        <g class="choice" (tap)="onClickOption(0)">
          <path d="M0 318 A318 318 0 0 1 31.49 180.02 L182.85 252.92 A150 150 0 0 0 168 318 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="23"  y="285" style="font-size:32px; fill: #4a4a4a;">非常无效</text>
        </g>
        <g class="choice" (tap)="onClickOption(1)">
          <path d="M31.49 180.02 A318 318 0 0 1 119.73 69.38 L224.48 200.73 A150 150 0 0 0 182.85 252.92 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="95"  y="180" style="font-size:32px; fill: #4a4a4a;">无效</text>
        </g>
        <g class="choice" (tap)="onClickOption(2)">
          <path d="M119.73 69.38 A318 318 0 0 1 247.24 7.97 L284.62 171.76 A150 150 0 0 0 224.48 200.73 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="157"  y="100" style="font-size:32px; fill: #4a4a4a;">较无效</text>
        </g>
        <g class="choice" (tap)="onClickOption(3)">
          <path d="M247.24 7.97 A318 318 0 0 1 388.76 7.97 L351.38 171.76 A150 150 0 0 0 284.62 171.76 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="285"  y="65" style="font-size:32px; fill: #4a4a4a;">一般</text>
        </g>
        <g class="choice" (tap)="onClickOption(4)">
          <path d="M388.76 7.97 A318 318 0 0 1 516.27 69.38 L411.52 200.73 A150 150 0 0 0 351.38 171.76 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="383"  y="100" style="font-size:32px; fill: #4a4a4a;">较有效</text>
        </g>
        <g class="choice" (tap)="onClickOption(5)">
          <path d="M516.27 69.38 A318 318 0 0 1 604.51 180.02 L453.15 252.92 A150 150 0 0 0 411.52 200.73 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="480"  y="180" style="font-size:32px; fill: #4a4a4a;">有效</text>
        </g>
        <g class="choice" (tap)="onClickOption(6)">
          <path d="M604.51 180.02 A318 318 0 0 1 636 318 L468 318 A150 150 0 0 0 453.15 252.92 Z" fill="white" stroke="#f1f2f6" stroke-width="5"></path>
          <text x="485"  y="285" style="font-size:32px; fill: #4a4a4a;">非常有效</text>
        </g>
      </svg>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/question/question.component.html